import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Box, IconButton, Tooltip } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useSnackbar } from '@contexts/SnackbarContext';
import API from '@utils/axios';

const SimulateSmsResponse = ({ url, onSuccess, ...params }) => {
    const { t } = useTranslation();
    const { showMessage } = useSnackbar();
    const [content, setContent] = useState('');

    const handleSubmit = async () => {
        try {
            const response = await API.post(url, content, {
                headers: {
                    'Content-Type': 'text/plain'
                }
            });
            if (response.status === 200 && response.data.success) {
                showMessage(t('SMS response sent'), 'success');
                onSuccess();
            } else {
                showMessage(t('Failed to send SMS response'), 'error');
                console.error('Failed to send SMS response:', response.data);
            }
        } catch (error) {
            showMessage(t('Failed to send SMS response'), 'error');
            console.error('Failed to send SMS response:', error);
        }
    };

    return (
        <Box {...params} sx={{ display: 'flex', alignItems: 'center', gap: 1, ...params.sx }}>
            <TextField 
                label={t('Simulate a response')} 
                value={content} 
                onChange={(e) => setContent(e.target.value)} 
                fullWidth 
            />
            <Tooltip title={t('Send')}>
                <IconButton 
                    color="primary"
                    onClick={handleSubmit}
                    aria-label={t('Simulate SMS')}
                    disabled={!content}
                    sx={{ mr: -2 }}
                >
                    <SendIcon />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default SimulateSmsResponse;
